/*
 * @Date: 2023-03-01 09:52:51
 * @LastEditTime: 2023-03-02 09:52:51
 * @LastEditors: roccoli
 * @Description: 
 * @FilePath: \pm_md:\workspace\plc_web\src\pc\views\home\pages\index\index.js
 * ©lexin ec-frd
 */
import M_REQUEST from '~request@1.0'
import M_TOOLKIT from '~toolkit@1.0'
import Swiper from '@pc/components/libs/swiper/swiper.6.5.0.js'
// 测试流水线

const G_REQUEST = new M_REQUEST({ gatewayType: 'platform' })
// let G_SWIPER = null
export default {
	data () {
		return {
			curSwiperIndex: 0, // 下标
			dropdownShowMap: {}, // 下拉菜单显示map
			hover: false, // 是否悬浮于下拉菜单

			pageLogo: '', // 头部logo
			pageQrCode: '', // 头部二维码
			footerQrCode: '', // 底部二维码
			footerQrCodeDesc: '', // 底部二维码描述
			contactInfo: {}, // 客服电话信息
			entryList: [], // 底部入口列表
			linkList: [], // 底部链接列表
			cerImgList: [], // 底部证书图片列表
			mainList: [], // 主内容列表
			navList: [] // 顶部导航
		}
	},

	computed: {
		/**
		 * 是否展示顶部导航条
		 * @returns {Boolean}
		 */
		isShowHeaderBar () {
			let data = this.mainList[this.curSwiperIndex] || {}

			// 数据返回字段控制头部是否展示，以接口为准
			if (data.showHeader !== undefined) {
				return +data.showHeader === 1
			} else {
				return this.curSwiperIndex > 0
			}
		}
	},

	methods: {
		/**
		 * 查询页面配置
		 */
		queryPageConfig () {
			G_REQUEST.ajax({
				url: '/route0014/platform/acc/querySceneMsg.json',
				data: {
					scene: 'fqlIndex',
				}
			}).then(res => {

				if (+res.retcode === 0) {
					let ret_data = (res && res.result_rows) || {}

					this.pageLogo = ret_data.pageLogo || ''
					this.pageQrCode = ret_data.pageQrCode || ''
					this.footerQrCode = ret_data.footerQrCode || ''
					this.footerQrCodeDesc = ret_data.footerQrCodeDesc || ''
					this.contactInfo = ret_data.contactInfo || {}
					this.mainList = ret_data.mainList || []
					this.entryList = ret_data.entryList || []
					this.linkList = ret_data.linkList || []
					this.cerImgList = ret_data.cerImgList || []
					// 未登录是不展示个人中心，暂时先写死，日后价格标志符存到配置文件
					let nav_list = (ret_data.navList || []).filter(item => {
						return !item.children
					})
					// 是否登录
					let is_login = this.checkLogin(res.system)

					this.navList = is_login ? (ret_data.navList || []) : nav_list
					// 数据更新后更新视图
					this.$nextTick( ()=> {
						// 放开展示
						this.$refs.main_wrap.hidden = false
						// 初始化swiper
						this.initSwiper()
					})
				}

			})
	
		},

		/**
		 * 获取页面样式
		 * @param {Object} page 页面配置
		 * @returns {Object}
		 */
		getPageBgStyle (page) {
			page = page || {}

			return {
				backgroundImage: 'url(' + page.bgImg + ')',
				backgroundColor: page.bgColor
			}
		},

		/**
		 * 顶部导航文字图片样式
		 * @param {Object} data 
		 * @returns {Object}
		 */
		getHeaderGuideStyle (data) {
			data = data || {}

			let style = M_TOOLKIT.extend({
				display: 'inline-block',
				position: 'absolute',
				backgroundRepeat: 'no-repeat',
				cursor: 'pointer'
			}, data.style || {})

			if (data.img) {
				style.backgroundImage = 'url(' + data.img + ')'
			}

			return style
		},

		/**
		 * 获取页面内容样式
		 * @param {Object} content 内容配置
		 * @returns {Object}
		 */
		getPageContentStyle (content) {
			content = content || {}

			let style = M_TOOLKIT.extend({
				position: 'absolute',
				backgroundRepeat: 'no-repeat',
				backgroundSize: '100%'
			}, content.style || {})

			if (content.img) {
				style.backgroundImage = 'url(' + content.img + ')'
			}

			return style
		},

		/**
		 * 获取页面按钮样式
		 * @param {Object} btn 按钮配置
		 * @returns {Object}
		 */
		getPageBtnStyle (btn) {
			btn = btn || {}

			let style = M_TOOLKIT.extend({
				position: 'absolute',
				cursor: 'pointer',
				fontSize: '22px',
				lineHeight: '42px',
				textAlign: 'center',
				textDecoration: 'none',
				transform: 'translateY(100%)' // 布局在图片下方
			}, btn.style || {})

			return style
		},

		/**
		 * 格式化请求数据
		 * @param {Object} data 请求数据
		 * @returns {Object}
		 */
		formatReqData (data) {
			// 请求要求JSON 字符串传参
			return JSON.stringify({
				data: data,
				system: {}
			})
		},

		/**
		 * 最后一页offset
		 * @return {Number} 
		 */
		getLastOffset () {
			let last_offset = document.body.clientHeight - this.$refs.footer.scrollHeight

			return Math.min(0, -last_offset)
		},
		/**
		 * 隐藏下拉菜单
		 * @param {Number} key 键名
		 * @param {Boolean} show 是否展示
		 */
		handleDropdownShow(key, show){
			
			setTimeout(() => {  
				//如果此时鼠标离开标题且悬浮于下拉菜单，则不触发事件
				if(!show && this.hover){
					return
				}
				this.$set(this.dropdownShowMap, key, show)
			}, 200);
		},
		/**
		 * 下拉菜单
		 * @param {Number} key 键名
		 * @param {Boolean} isHover 是否悬浮在下拉菜单
		 */
		handleDropdownHover(key, isHover){

			this.hover = isHover
			if(!isHover){
				setTimeout(() => {
					this.$set(this.dropdownShowMap, key, isHover)
				},200);
			}
		},
		/**
		 * 点击链接
		 * @param {String} url 
		 */
		handleToLink(url){
			if (url){
				window.location.href = url
			}
		},
		/**
		 * 验证是否登录
		 * @param {Object} system_data 
		 * @returns {Boolean}
		 */
		checkLogin (system_data) {
			return !!(system_data && system_data.session_id && system_data.token_id && system_data.uid)
		},
		/**
		 * 初始化swiper
		 */
		initSwiper () {
			
			G_SWIPER = new Swiper ('.swiper-container', {
				direction: 'vertical', // 垂直切换选项
				loop: false, // 循环模式选项
				mousewheel: true, // 滚轮切换
				speed: 1000, // 切换速度(ms)
				slidesOffsetAfter: this.getLastOffset(), // 最后一页offset
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				on: {
					transitionEnd: function (swiper) {
						// 监听下标改动
						this.curSwiperIndex = swiper.activeIndex
					}
				}
			})
		}
	},

	mounted () {
		this.queryPageConfig()
	},

	created () {
		let e1 = /\bfenqile_(ios|android)_(\d+\.\d+\.\d+)\b/.test(navigator.userAgent)
        let e2 = /\b(Android|iPhone|iPad|Mobile|Mobi|IEMobile)\b/i.test(navigator.userAgent)
        if (e1 || e2) {
            location.href = '//m.fenqile.com'
        }
	}
}